"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _DropdownList = _interopRequireDefault(require("react-widgets/lib/DropdownList"));
var _Multiselect = _interopRequireDefault(require("react-widgets/lib/Multiselect"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdDatepicker = _interopRequireDefault(require("cccisd-datepicker"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _formWrapper = require("../../../reducers/formWrapper.js");
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AppDefinitions = window.cccisd.appDefs;
var FieldMapper = /*#__PURE__*/function (_React$Component) {
  function FieldMapper() {
    var _this;
    _classCallCheck(this, FieldMapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FieldMapper, [].concat(args));
    _defineProperty(_this, "state", {
      busy: false,
      filteredQueryData: [],
      focusedBefore: false,
      graphqlParams: undefined
    });
    _defineProperty(_this, "componentDidMount", function () {
      var _this$props = _this.props,
        graphqlSettings = _this$props.graphqlSettings,
        operation = _this$props.operation;
      if ((0, _get2["default"])(graphqlSettings, 'edit.filterQuery') && !_this.state.focusedBefore && operation === 'edit') {
        _this.onFocus();
      }
    });
    /* /////////////////////////////////////////////////////////////////////////
    // CLASS METHODS //////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */
    _defineProperty(_this, "getFieldBlockSettings", function () {
      var _this$props2 = _this.props,
        displaySettings = _this$props2.displaySettings,
        field = _this$props2.field,
        validationSettings = _this$props2.validationSettings;
      return {
        field: field,
        label: /*#__PURE__*/_react["default"].createElement("span", null, displaySettings.label || '', displaySettings.toolTip && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: displaySettings.toolTip
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "text-primary"
        }, /*#__PURE__*/_react["default"].createElement(_info["default"], {
          spaceLeft: true
        })))),
        required: validationSettings && validationSettings.isRequired ? validationSettings.isRequired : false
      };
    });
    _defineProperty(_this, "onChangeProxy", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
        var arg;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              arg = event instanceof Event ? event.target.value : event;
              _context.n = 1;
              return _this.props.changeAllFields(arg, _this.props);
            case 1:
              if (_this.props.isUserCheckField && _this.props.shouldCheckUser) {
                _this.props.runCheckUser();
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "onFocus", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var _this$props3, graphqlSettings, operation, gqlStgs, reduxForm, gqlParams, shouldRun;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _this.setState({
              focusedBefore: true
            });
            _this$props3 = _this.props, graphqlSettings = _this$props3.graphqlSettings, operation = _this$props3.operation;
            if (!(!graphqlSettings || !graphqlSettings[operation])) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2, false);
          case 1:
            gqlStgs = graphqlSettings[operation];
            reduxForm = _this.props.reduxForm && _this.props.reduxForm.DynamicForm;
            if (!(gqlStgs.filterQuery && gqlStgs.requiredVariables && reduxForm)) {
              _context2.n = 2;
              break;
            }
            gqlParams = {};
            shouldRun = false;
            gqlStgs.requiredVariables.forEach(function (rq) {
              if (rq.reduxField) {
                var reduxValue = reduxForm[rq.reduxField].value;
                gqlParams[rq.variable] = reduxValue;
                if (reduxValue && !Array.isArray(reduxValue) && rq.reduxValueNotArray && (!_this.state.graphqlParams || _this.state.graphqlParams[rq.variable] !== reduxValue)) {
                  shouldRun = true;
                }
              }
            });
            if (!shouldRun) {
              _context2.n = 2;
              break;
            }
            _context2.n = 2;
            return _this.updateQueryData(gqlStgs.filterQuery, gqlParams);
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    })));
    return _this;
  }
  _inherits(FieldMapper, _React$Component);
  return _createClass(FieldMapper, [{
    key: "updateQueryData",
    value: (
    /**
     * Set the filteredQueryData if we have a new reduxValue.
     * @param {Object} gqlSettings The GraphQL settings for this field
     * @param {mixed} reduxValue The value set by the referenced redux form field
     * @param {Object} gqlParams The parameters to include in the GraphQL query
     */
    function () {
      var _updateQueryData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(query, gqlParams) {
        var response;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.setState({
                busy: true
              });
              _context3.n = 1;
              return _cccisdApollo.client.query({
                query: (0, _cccisdApollo.gql)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n                ", "\n            "])), query),
                fetchPolicy: 'network-only',
                variables: gqlParams
              });
            case 1:
              response = _context3.v;
              this.setState({
                busy: false,
                filteredQueryData: response.data,
                graphqlParams: gqlParams
              });
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function updateQueryData(_x2, _x3) {
        return _updateQueryData.apply(this, arguments);
      }
      return updateQueryData;
    }()
    /* /////////////////////////////////////////////////////////////////////////
    // RENDER /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */
    )
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        displaySettings = _this$props4.displaySettings,
        emptyValue = _this$props4.emptyValue,
        field = _this$props4.field,
        graphqlSettings = _this$props4.graphqlSettings,
        isDisabled = _this$props4.isDisabled,
        loadedData = _this$props4.loadedData,
        operation = _this$props4.operation,
        requiredByFields = _this$props4.requiredByFields,
        validationSettings = _this$props4.validationSettings;
      var DOMField = '';
      var data = [];
      var isMulti = displaySettings.selectionType === 'multi';
      var _groupBy = 'fieldProps' in displaySettings && displaySettings.fieldProps.groupBy || {};
      var createGroupLabelByValueMap = function createGroupLabelByValueMap(d) {
        var valuePath = _groupBy.valuePath,
          labelPath = _groupBy.labelPath;
        return valuePath ? d.reduce(function (a, c) {
          var value = (0, _get2["default"])(c, valuePath);
          var label = (0, _get2["default"])(c, labelPath);
          a[value] = value ? label : '---';
          return a;
        }, {}) : {};
      };
      switch (displaySettings.renderAs) {
        case 'checkbox':
          DOMField = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, Object.assign(this.getFieldBlockSettings(), {
            label: ''
          }), /*#__PURE__*/_react["default"].createElement("div", {
            className: "form-check"
          }, /*#__PURE__*/_react["default"].createElement("input", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(field), {
            type: "checkbox",
            className: "form-check-input",
            name: "checkBoxInput"
          })), /*#__PURE__*/_react["default"].createElement("label", {
            className: "form-check-label",
            htmlFor: "checkBoxInput"
          }, /*#__PURE__*/_react["default"].createElement("span", null, displaySettings.label || '', displaySettings.toolTip && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: displaySettings.toolTip
          }, /*#__PURE__*/_react["default"].createElement("span", {
            className: "text-primary"
          }, /*#__PURE__*/_react["default"].createElement(_info["default"], {
            spaceLeft: true
          })))))));
          break;
        case 'date':
          DOMField = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, this.getFieldBlockSettings(), /*#__PURE__*/_react["default"].createElement(_cccisdDatepicker["default"], _extends({
            disabled: isDisabled,
            onChange: this.onChangeProxy,
            placeholderText: displaySettings.placeholder || '',
            selected: field.value,
            useDateFormatAsPlaceholder: displaySettings.useDateFormatAsPlaceholder
          }, displaySettings.fieldProps)));
          break;
        case 'dateTime':
          DOMField = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, this.getFieldBlockSettings(), /*#__PURE__*/_react["default"].createElement(_cccisdDatepicker["default"], _extends({
            dateFormat: displaySettings.dateFormat ? displaySettings.dateFormat : 'LLL d, yyyy h:mm a',
            disabled: isDisabled,
            onChange: this.onChangeProxy,
            placeholderText: displaySettings.placeholder || '',
            selected: field.value,
            showTimeSelect: true,
            timeCaption: "time",
            timeFormat: "HH:mm",
            timeIntervals: 30,
            useDateFormatAsPlaceholder: displaySettings.useDateFormatAsPlaceholder
          }, displaySettings.fieldProps)));
          break;
        case 'enum':
          {
            data = !(0, _isEmpty2["default"])((0, _filter2["default"])(AppDefinitions.pawn.fields, function (f) {
              return f.handle === displaySettings.enumFieldHandle;
            })) ? (0, _cloneDeep2["default"])((0, _filter2["default"])(AppDefinitions.pawn.fields, function (f) {
              return f.handle === displaySettings.enumFieldHandle;
            })[0].values) : [];
            if (!isMulti && !(0, _isEmpty2["default"])(data) && 'placeholder' in displaySettings) {
              var object = {
                value: emptyValue || '',
                name: displaySettings.placeholder
              };
              data.unshift(object);
            }
            var groupLabelByValue = createGroupLabelByValueMap(data);
            var GroupLabel = function GroupLabel(_ref3) {
              var item = _ref3.item;
              return /*#__PURE__*/_react["default"].createElement("span", null, groupLabelByValue[item]);
            };
            DOMField = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, this.getFieldBlockSettings(), isMulti ? /*#__PURE__*/_react["default"].createElement(_Multiselect["default"], _extends({}, displaySettings.fieldProps, {
              busy: this.state.busy,
              data: data,
              disabled: isDisabled,
              filter: "contains",
              onChange: function onChange(value) {
                return _this2.onChangeProxy(value.map(function (d) {
                  return d.value;
                }));
              },
              onFocus: this.onFocus,
              placeholder: displaySettings.placeholder || '',
              textField: function textField(item) {
                return (0, _get2["default"])(item, 'name');
              },
              valueField: "value",
              value: field.value,
              groupBy: function groupBy(item) {
                return (0, _get2["default"])(item, _groupBy.valuePath);
              },
              groupComponent: GroupLabel
            })) : /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], _extends({}, (0, _omit2["default"])(displaySettings.fieldProps, ['initialValue']), {
              busy: this.state.busy,
              data: data,
              disabled: isDisabled,
              onBlur: field.onBlur,
              onChange: function onChange(item) {
                return _this2.onChangeProxy((0, _get2["default"])(item, 'value'));
              },
              onFocus: this.onFocus,
              placeholder: displaySettings.placeholder || '',
              textField: function textField(item) {
                return (0, _get2["default"])(item, 'name');
              },
              value: data.find(function (option) {
                return (0, _get2["default"])(option, 'value') === field.value;
              })
            })));
            break;
          }
        case 'hidden':
          DOMField = /*#__PURE__*/_react["default"].createElement("input", _extends({
            type: "hidden"
          }, (0, _cccisdReduxFormHelpers.domOnlyProps)(field), {
            onChange: this.onChangeProxy
          }));
          break;
        case 'input':
          // if requiredByFields is not empty we need custom onChange
          // handler and need to render FieldBlock instead
          // TODO: Is this distinction needed? They both have the same onChange!
          if (!(0, _isEmpty2["default"])(requiredByFields)) {
            DOMField = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, this.getFieldBlockSettings(), /*#__PURE__*/_react["default"].createElement("input", {
              className: "form-control",
              disabled: isDisabled,
              onBlur: field.onBlur,
              onChange: this.onChangeProxy,
              placeholder: displaySettings.placeholder || '',
              value: field.value
            }));
          } else {
            DOMField = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
              disabled: isDisabled,
              field: field,
              label: /*#__PURE__*/_react["default"].createElement("span", null, displaySettings.label || '', displaySettings.toolTip && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
                title: displaySettings.toolTip
              }, /*#__PURE__*/_react["default"].createElement("span", {
                className: "text-primary"
              }, /*#__PURE__*/_react["default"].createElement(_info["default"], {
                spaceLeft: true
              })))),
              onChange: this.onChangeProxy,
              placeholder: displaySettings.placeholder || '',
              required: validationSettings && validationSettings.isRequired ? validationSettings.isRequired : false
            });
          }
          break;
        case 'instructionalText':
          {
            if (isDisabled) {
              DOMField = null;
              break;
            }
            var text = displaySettings.instructionalText;
            if (displaySettings.requiredVariables) {
              displaySettings.requiredVariables.forEach(function (replaceVariable) {
                var value = (0, _get2["default"])(loadedData, replaceVariable.field);
                if (!(0, _isNil2["default"])(value)) {
                  text = text.replace("%".concat(replaceVariable.variable, "%"), value);
                } else if ('defaultValue' in replaceVariable) {
                  text = text.replace("%".concat(replaceVariable.variable, "%"), replaceVariable.defaultValue);
                }
              });
            }
            DOMField = /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
              content: text
            }));
            break;
          }
        case 'select':
          {
            var _textField = 'name';
            var valueField = 'value';
            if ('options' in displaySettings) {
              // if the options are enumerated in display settings
              // we should follow the construct 'name' and 'value'

              data = displaySettings.options;
              if ('placeholder' in displaySettings) {
                var hasPlaceholder = data.find(function (e) {
                  return e.name === displaySettings.placeholder;
                });
                if (!hasPlaceholder) {
                  var _object = {
                    value: emptyValue || '',
                    name: displaySettings.placeholder
                  };
                  data.unshift(_object);
                }
              }
            } else {
              // get select options from graphql

              // if no graphqlSettings, this no longer makes sense
              if ((0, _isEmpty2["default"])(graphqlSettings) || !graphqlSettings[operation]) {
                return;
              }
              var gqlStgs = graphqlSettings[operation];

              // Use filteredQueryData if we rely upon a reduxField,
              // loadedData otherwise.
              var dataInextensible = gqlStgs.filterQuery ? (0, _get2["default"])(this.state.filteredQueryData, gqlStgs.optionsPath) : (0, _get2["default"])(loadedData, gqlStgs.optionsPath);

              // if no textFieldPath or valueFieldPath it will
              // assume there is "name" and "value" in the top level
              if (gqlStgs.fieldSettings) {
                _textField = gqlStgs.fieldSettings.textFieldPath;
                valueField = gqlStgs.fieldSettings.valueFieldPath;
              }
              if ('placeholder' in displaySettings && !isMulti) {
                var _object2 = {};
                _object2 = (0, _set2["default"])(_object2, gqlStgs.fieldSettings.textFieldPath, displaySettings.placeholder);

                // let's cheat the redux form value by setting it back to the
                // empty value
                _object2 = (0, _set2["default"])(_object2, gqlStgs.fieldSettings.valueFieldPath, emptyValue);
                data.push(_object2);
              }
              data = data.concat(dataInextensible);
              if (isMulti) {
                data = data.map(function (d) {
                  return _objectSpread(_objectSpread({}, d), {}, {
                    _value: (0, _get2["default"])(d, valueField)
                  });
                });
              }
            }
            var _groupLabelByValue = createGroupLabelByValueMap(data);
            var _GroupLabel = function _GroupLabel(_ref4) {
              var item = _ref4.item;
              return /*#__PURE__*/_react["default"].createElement("span", null, _groupLabelByValue[item]);
            };
            DOMField = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, this.getFieldBlockSettings(), isMulti ? /*#__PURE__*/_react["default"].createElement(_Multiselect["default"], _extends({}, displaySettings.fieldProps, {
              busy: this.state.busy,
              data: data,
              disabled: isDisabled,
              filter: "contains",
              onChange: function onChange(value) {
                return _this2.onChangeProxy(value.map(function (d) {
                  return d._value;
                }));
              },
              onFocus: this.onFocus,
              placeholder: displaySettings.placeholder || '',
              textField: function textField(item) {
                return (0, _get2["default"])(item, _textField);
              },
              valueField: "_value",
              value: field.value,
              groupBy: function groupBy(item) {
                return (0, _get2["default"])(item, _groupBy.valuePath);
              },
              groupComponent: _GroupLabel
            })) : /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], _extends({}, (0, _omit2["default"])(displaySettings.fieldProps, ['initialValue']), {
              busy: this.state.busy,
              data: data,
              disabled: isDisabled,
              onBlur: field.onBlur,
              onChange: function onChange(item) {
                return _this2.onChangeProxy((0, _get2["default"])(item, valueField));
              },
              onFocus: this.onFocus,
              placeholder: displaySettings.placeholder || '',
              textField: function textField(item) {
                return (0, _get2["default"])(item, _textField);
              },
              value: data.find(function (option) {
                return (0, _get2["default"])(option, valueField) === field.value;
              })
            })));
            break;
          }
        case 'toggle':
          DOMField = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, Object.assign(this.getFieldBlockSettings(), {
            label: ''
          }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(field), {
            label: /*#__PURE__*/_react["default"].createElement("span", null, displaySettings.label || '', displaySettings.toolTip && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
              title: displaySettings.toolTip
            }, /*#__PURE__*/_react["default"].createElement("span", {
              className: "text-primary"
            }, /*#__PURE__*/_react["default"].createElement(_info["default"], {
              spaceLeft: true
            }))))
          })))));
          break;
        case 'textarea':
        default:
          DOMField = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, this.getFieldBlockSettings(), /*#__PURE__*/_react["default"].createElement("textarea", _extends({
            className: "form-control",
            rows: 3
          }, (0, _cccisdReduxFormHelpers.domOnlyProps)(field), {
            disabled: isDisabled
          })));
          break;
      }
      return DOMField;
    }
  }]);
}(_react["default"].Component);
_defineProperty(FieldMapper, "propTypes", {
  /**
   * Callback to change the redux value of the field AND all fields that
   * depend on it
   */
  changeAllFields: _propTypes["default"].func,
  displaySettings: _propTypes["default"].object,
  emptyValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].object, _propTypes["default"].array, _propTypes["default"].bool]),
  /** The redux form fields object */
  field: _propTypes["default"].object.isRequired,
  /** Each appdef field, keyed by handle (needed for changeAllFields) */
  fieldTypes: _propTypes["default"].object,
  /** GraphQL appdef settings */
  graphqlSettings: _propTypes["default"].object,
  isDisabled: _propTypes["default"].bool,
  /** Is this field a field that needs userCheck? */
  isUserCheckField: _propTypes["default"].bool,
  /** All data loaded from graphql */
  loadedData: _propTypes["default"].object,
  /** 'create' or 'edit' */
  operation: _propTypes["default"].string,
  /** The reduxForm, from mapStateToProps */
  reduxForm: _propTypes["default"].object,
  /**
   * Array of field handles which should be set to the same value as this
   * field, keyed by handles (needed for changeAllFields)
   */
  requiredByFields: _propTypes["default"].object,
  /** Run the checkUser function */
  runCheckUser: _propTypes["default"].func,
  /** Whether we need to run the check or not */
  shouldCheckUser: _propTypes["default"].bool,
  validationSettings: _propTypes["default"].object
});
_defineProperty(FieldMapper, "defaultProps", {
  isDisabled: false
});
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    reduxForm: state.form
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  changeAllFields: _formWrapper.changeAllFields
})(FieldMapper);